import AutoFixHigh from "@mui/icons-material/AutoFixHigh";
import FileUpload from "@mui/icons-material/FileUpload";
import { Box, Button, Typography } from "@mui/material";
import type { FC } from "react";
import { HeaderBar } from "../../generic/components/header-bar";

export const ContentLibraryHeader: FC<{ onUpload: () => void }> = ({ onUpload }) => {
  return (
    <HeaderBar navBurger>
      <Typography variant="body1" fontWeight={700} fontSize={16}>
        Content Library
      </Typography>
      <Box>
        <Button
          onClick={onUpload}
          variant="outlined"
          color="primary"
          data-analytics-id="content-library-upload-file"
          startIcon={<FileUpload />}
          sx={{ mr: 2 }}
        >
          Upload file
        </Button>
        <Button
          variant="contained"
          color="primary"
          href="/"
          data-analytics-id="content-library-create-content-cta"
          startIcon={<AutoFixHigh />}
        >
          Create Content
        </Button>
      </Box>
    </HeaderBar>
  );
};
